// Where this app signs in and where it reads data.
//
// The pool and client ids are not secrets. They are published in every browser
// that loads this app, and they identify rather than authorize. What authorizes
// is the token Cognito issues after a real sign-in, and the Postgres role that
// token maps to.
export const COGNITO = {
  region: "us-east-2",
  userPoolId: "us-east-2_oQXs4FJbf",
  clientId: "3p053l1po9ni55ahs8h73p0p10",
} as const;

// Same origin, always. Caddy serves this app and proxies /api to PostgREST on
// the same hostname, so there is no cross-origin request to configure and no
// second address that can drift out of date. In development, vite.config.ts
// proxies /api the same way.
//
// Absolute, built from the origin at load. This was "/api" and every data
// screen in the app failed on it, because PostgrestClient calls new URL() on
// its base and new URL("/api") throws "Failed to construct 'URL': Invalid URL".
// A relative path needs a base and the constructor has none.
//
// Two things hid it. Sign-in is Cognito and worked, so the app looked alive
// and only the data was missing. And deploy/check_screens.sh talks to the API
// directly rather than through the browser, so 43 passing checks said nothing
// about the one line that decides whether a browser can reach it at all.
// Nothing caught this until somebody opened the app.
//
// Reading location at module load is safe because this only runs in a browser,
// and it keeps the same-origin property: in development the origin is the vite
// server, which proxies /api exactly as Caddy does.
//
// FILES_BASE below stays relative on purpose. It is only passed to fetch(),
// which resolves a relative path against the document.
export const API_BASE = new URL("/api", window.location.origin).href;

// Where download links are signed. Same origin again, one more route on the
// hostname Caddy already serves, so a download needs no second address and no
// cross-origin configuration.
export const FILES_BASE = "/files";

// The most rows PostgREST will return for one request, set by PGRST_DB_MAX_ROWS
// on the box. A download asks for the whole narrowed set rather than the page
// on screen, and this is where that stops. It is a real ceiling, not a default:
// a request for more gets this many and a header saying how many exist.
export const API_ROW_CEILING = 1000;
